<template>
<div class="chapter">
<div class="inner_page">
<p class="h1bb" id="d7e140623"><span>amaranth</span></p>
<p class="h3" id="d7e141123"><span>(een choi, bledo, alegria)</span></p>
<p class="h4" id="d7e141623"><span>A<span class="small"><span class="small">MARANTHUS SPP.</span></span></span></p>
<p class="tx1" id="d7e142323"><span>As amaranth, this fleshy green or reddish potherb has been enjoying a modest renaissance, particularly for the nutritional virtues of its tiny seeds. As pigweed, amaranth is still the same old garden weed it ever was. It is up early in the spring, and the young leaves are a reasonable substitute for spinach. As they get tougher and stronger tasting, leaves should be treated like chard. I add the odd bit of amaranth to stir-fries and mixed-green dishes such as hortopita.</span></p>
<p class="tx" id="d7e145023"><span>Most country dwellers probably have some pigweed around for the foraging, so you can check out the flavor before committing yourself to a garden crop. Commercial seed yields a variety of colors and sizes, making amaranth a popular choice for edible landscapers. An ornamental variety, often sold in flower catalogs as a giant Love Lies Bleeding, has red leaves that look lovely in a spring salad. Another, marketed by Territorial Seeds as Double Color, has purple leaves with green edges.</span></p>
<p class="h1a" id="d7e147923"><span>apples</span></p>
<p class="tx1" id="d7e148423"><span>Apples are a late-summer to late-fall crop by nature. Cold storage and wax coverings (and shipping from New Zealand) make them available year-round. The trick for gardeners and local eaters is to find out what grows best, and keeps best, in your region without commercial technology. Some varieties, such as Melrose, will keep improving in flavor until Christmas and keep in your refrigerator until March or April. Other late ripeners and good keepers include Ashmead’s Kernal, Fuji, and Idareds, which sometimes last until May.</span></p>
<p class="tx" id="d7e151323"><span>Conventionally grown apples regularly appear on the Dirty Dozen lists for pesticide and herbicide residues, and even here in</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morg_9781550924589_epub_c10_r1.vue?336a50e1